// extracted by mini-css-extract-plugin
module.exports = {"root":"Favourites_root__36rYM","titleContainer":"Favourites_titleContainer__1M5fm","title":"Favourites_title__LMiV-","noFavorites":"Favourites_noFavorites__15VMJ"};